import { render, staticRenderFns } from "./EpoHomeSnackbar.vue?vue&type=template&id=22997856&scoped=true&"
import script from "./EpoHomeSnackbar.vue?vue&type=script&lang=js&"
export * from "./EpoHomeSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./EpoHomeSnackbar.vue?vue&type=style&index=0&id=22997856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22997856",
  null
  
)

export default component.exports